import { getCanonical } from './../seo/useCases/getCanonicalForPath'
import { getIsLuxury, getSlug } from '../location'
import { isLuxuryFacetPageType } from '../../domain/useCases/pageTypeCheck'

export const computeLuxuryCanonical = (
  path = '',
  param = '',
  pageType,
  location
) => {
  const pathStr = String(path)
  if (isLuxuryFacetPageType(pageType, pathStr) && getIsLuxury(location)) {
    return `https://recovery.com/${getSlug(location)}/`
  }
  return getCanonical(pathStr, param)
}
